import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    FETCH_ACTIVE_CARD_TYPES,
    FETCH_CARD_TYPE,
    FETCH_CARD_TYPES,
    REMOVE_CARD_TYPES
} from './types';

const notifyError = (error, fallback) => {
    NotificationManager.error(error.response?.data?.msg || fallback);
};

export const fetchCardTypes = (filter) => dispatch => api
    .get('/card-types', { params: filter })
    .then(response => {
        dispatch({ type: FETCH_CARD_TYPES, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải danh sách loại thẻ.');
        return Promise.reject(error);
    });

export const fetchActiveCardTypes = () => dispatch => api
    .get('/card-types/active')
    .then(response => {
        dispatch({ type: FETCH_ACTIVE_CARD_TYPES, payload: response.data.data || [] });
        return response.data.data || [];
    })
    .catch(error => {
        notifyError(error, 'Không thể tải danh sách loại thẻ.');
        return Promise.reject(error);
    });

export const fetchCardType = id => dispatch => api
    .get(`/card-types/${id}`)
    .then(response => {
        dispatch({ type: FETCH_CARD_TYPE, payload: response.data.data });
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải loại thẻ.');
        return Promise.reject(error);
    });

export const createCardType = data => () => api
    .post('/card-types', data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tạo loại thẻ.');
        return Promise.reject(error);
    });

export const updateCardType = (id, data) => () => api
    .put(`/card-types/${id}`, data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể cập nhật loại thẻ.');
        return Promise.reject(error);
    });

export const removeCardTypes = ids => dispatch => api
    .delete('/card-types', { data: { ids } })
    .then(response => {
        dispatch({ type: REMOVE_CARD_TYPES, payload: ids });
        NotificationManager.success(response.data.msg);
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể xóa loại thẻ.');
        return Promise.reject(error);
    });
